import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { DIAL_CHOICES, DEFAULT_DIAL_ISO } from "@/lib/dialCodes";

export function PhoneCountryInput() {
  return (
    <AutocompleteInput
      source="dial_iso"
      label={false}
      helperText={false}
      choices={DIAL_CHOICES}
      defaultValue={DEFAULT_DIAL_ISO}
      placeholder="País"
      className="w-full min-w-0 sm:w-48"
    />
  );
}
